import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  const isAdminAttempt = location.pathname.startsWith('/admin');

  return (
    <div className="min-h-screen flex flex-col bg-dark-500">
      <Navbar />
      <main className="flex-grow flex items-center justify-center">
        <div className="text-center px-4">
          <h1 className="text-6xl font-bold text-gradient mb-4">404</h1>
          <p className="text-xl text-gray-300 mb-2">{isAdminAttempt ? "Access denied." : "Page not found."}</p>
          <p className="text-gray-400 mb-8">{isAdminAttempt 
            ? "That area is restricted. Move along." 
            : "The page you are looking for does not exist."}
          </p>
          <Link to="/" className="text-tasktide-teal hover:text-tasktide-blue transition-colors">
            ← Back to Home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;